import React from 'react';

/* PROPS 
 * add_class (optional)
 * side_title (required string)
 * content_text (required string)
 * onClick (required function)
 * sub_content_text (required string)
 * last_update_text (required string)
*/

class SGValueBox extends React.Component {
	constructor(props) {
		super(props);

		this.onEditClick = this.onEditClick.bind(this);

	}

	onEditClick(e) {
		this.props.onClick(e);
	}

	render() {

		var contentText = (typeof this.props.content_text !== 'undefined' 
								&& this.props.content_text.length) ? 
																	this.props.content_text : 'Not set';
		var subContentText = (typeof this.props.sub_content_text !== 'undefined' 
								&& this.props.sub_content_text.indexOf('undefined') === -1
								&& this.props.sub_content_text.length) ? 
																	this.props.sub_content_text : '';
		var lastUpdateText = (typeof this.props.last_update_text !== 'undefined' 
								&& this.props.last_update_text.indexOf('undefined') === -1
								&& this.props.last_update_text.length) ? 
																	this.props.last_update_text : '';
		return (
			<div className={this.props.add_class + ' SG-Value-Box'}>
				<div className="Left-Side-Title-Text">{this.props.side_title}</div>
				<div className="Right-Side-Content">
					<div className="Content-Area">
						<div className="Content-Text">{contentText}</div>
						<div className="Edit-Button"><button data-id={this.props.dataId} onClick={this.onEditClick}><img src={process.env.PUBLIC_URL + "images/pencil.png"} alt='pencil' /></button></div>
					</div>
					<div className="Sub-Text">{subContentText}</div>
					<div className="Last-Update-Text">{lastUpdateText}</div>
				</div>
			</div>
			);

	}
}

export default SGValueBox;